import { BaseModel, Column, Model } from 'scf-graphql-model'
import {Product} from "./product.model";
import {BookPriceOffer} from "./vouchers/book_price_offer.model";

@Model('bookLaunchOffer')
export class BookLaunchOffer extends BaseModel {
  @Column()
  countdown: number | undefined;
  @Column()
  product: Product | undefined;
  @Column()
  tiers: BookPriceOffer[] = [];
}
